export {};

const INIT_FLAG = 'stgbCircleLabelsInit';
const MODE_CLASSES = {
    mobile: 'is-mode-mobile',
    tablet: 'is-mode-tablet',
    desktop: 'is-mode-desktop',
} as const;

type Mode = keyof typeof MODE_CLASSES;

const initBlock = (block: HTMLElement) => {
    if (block.dataset[INIT_FLAG] === 'true') return;

    const tabletBreakpoint = parseInt(block.dataset.stgbTabletBreakpoint ?? '', 10) || 640;
    // The desktop breakpoint can never sit below the tablet one.
    const desktopBreakpoint = Math.max(
        parseInt(block.dataset.stgbDesktopBreakpoint ?? '', 10) || 960,
        tabletBreakpoint
    );
    const parent = block.parentElement ?? block;

    const applyLayout = (width: number) => {
        let mode: Mode;
        if (width < tabletBreakpoint) {
            mode = 'mobile';
        } else if (width < desktopBreakpoint) {
            mode = 'tablet';
        } else {
            mode = 'desktop';
        }

        // --- TEMP DIAGNOSTIC LOGGING (remove once the breakpoint issue is solved) ---
        const rectWidth = Math.round(parent.getBoundingClientRect().width);
        const winWidth = window.innerWidth;
        const clientWidth = document.documentElement.clientWidth;
        console.log(
            `[circle-labels] width is ${Math.round(width)}, changing to ${mode}` +
            ` — (parent rect: ${rectWidth}, window.innerWidth: ${winWidth},` +
            ` documentElement.clientWidth: ${clientWidth};` +
            ` breakpoints: mobile < ${tabletBreakpoint} ≤ tablet < ${desktopBreakpoint} ≤ desktop)`
        );
        if (rectWidth > clientWidth + 1) {
            console.warn(
                `[circle-labels] container is ${rectWidth - clientWidth}px WIDER than the screen` +
                ` (${rectWidth} vs ${clientWidth}) — something on the page is overflowing horizontally.`
            );
        }
        // --- END TEMP DIAGNOSTIC LOGGING ---

        (Object.keys(MODE_CLASSES) as Mode[]).forEach((key) => {
            block.classList.toggle(MODE_CLASSES[key], key === mode);
        });
    };

    if (typeof ResizeObserver !== 'undefined') {
        const observer = new ResizeObserver((entries) => {
            entries.forEach((entry) => applyLayout(entry.contentRect.width));
        });
        observer.observe(parent);
    } else {
        window.addEventListener('resize', () => {
            applyLayout(parent.getBoundingClientRect().width);
        });
    }

    applyLayout(parent.getBoundingClientRect().width);
    block.dataset[INIT_FLAG] = 'true';
};

const initAll = () => {
    document
        .querySelectorAll<HTMLElement>('.stgb-circle-labels')
        .forEach(initBlock);
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
} else {
    initAll();
}
